import { BaseReferralClient } from "../types/clients";
import { InviteVariables, Invitation, DeleteInvitationVariables, ReferralStats } from "@core/types";

class ReferralClient extends BaseReferralClient {
  async invite(variables: InviteVariables): Promise<any> {
    const { data } = await this.instance.post("/wp-json/parhato-api/v1/invitations", variables);
    return data;
  }

  async getInvitations(): Promise<Invitation[]> {
    const { data } = await this.instance.get("/wp-json/parhato-api/v1/invitations");
    return data;
  }

  async deleteInvitation(variables: DeleteInvitationVariables): Promise<any> {
    const { data } = await this.instance.delete(`/wp-json/parhato-api/v1/invitations/${variables.id}`);
    return data;
  }

  // Updated method to fetch referral points
  async getReferralPoints(): Promise<number> {
    const { data } = await this.instance.get(`/wp-json/parhato-api/v1/referral-points`);
    return data.points;
  }

  async checkWasInvited(variables: InviteVariables): Promise<any> {
    throw new Error("checkWasInvited not implemented");
  }

  async getReferralStats(): Promise<ReferralStats | null> {
    throw new Error("getReferralStats not implemented");
  }
}

export default ReferralClient;
